export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const TIME_AM_PM_FORMAT = 'h:mm A';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_TIME_AM_PM_FORMAT = 'YYYY-MM-DD h:mm A';
